export default "__VITE_ASSET__B7YLM835__"